/* Addexport Button, m_exportData,fn_exportExcel,fn_getNestedValue, import VueExcelXlsx Feb 27 2022 */
/* Add MapView Oct 23, 20222 */
/*Add Pdf Reports Mar 25, 2023 */
/* Add Table level Reminders and Notifications Apr 29, 2023 */
/* Add close button  Jun 17, 2023 */
/* Amend fn_getAppUserSettings for customFields Aug 5, 2023 */
/* Amend created() to test for contextId>0 Oct 21, 2023 */
/* Add d_componentKey, p_appEntKey Feb 3, 2024 */
/* Add .btn-outline-secondary,btn-menu, amend colIndex APr 13, 2024 */
/* Add to d_search,input-search size and width, add search icon,Move search to Front End Oct 5, 2024 */
/* Add readOnly, required columns Jan 25, 2025 */
/* Add required Indicator Feb 15, 2025 */
/* Add Table Edit Mar 22, 2025 */
/* Add kt-barpiechart April 15, 2025 */
/* Add p_filters to filtercomponent Oct 25, 2025 */
/* Hide column width/sort resets for Gantt View TG Oct 3, 2026 */
<template lang="pug">
	div(class="kt-toolbar" :class="p_ctrlKey")
		div
			slot(name="toolbar-left")
		div
			slot(name="toolbar-right-l")
			div(v-if="d_showBtns.searchBar" class="searchBar" )
				b-input(id="searchBar" v-if="p_enableSearch" class="input-search" v-model="d_search" type="search" placeholder="Search Current Scope" size=100 @search="m_search")
				fa-icon(v-if="!d_search" icon="search")
				input(class="searchCheckbox"  type="checkbox" :checked="d_responsiveSearch" title="Responsive search" @click="m_toggleSearch")
			div(v-if="p_tableEdit && d_showBtns.saveCancel" class="d-flex")
				b-button(id="btn-save" class="btn-save"  title="Save" variant="none" @click="m_tableSave()") 
					fa-icon(icon="save" class="mr-1")
					sup Save
				b-button(id="btn-cancel" class="btn-cancel" title="Cancel" variant="none" @click="m_tableCancel()") 
					fa-icon(icon="undo" class="mr-1")
					sup Cancel
			filter-component(v-if="d_showBtns.filterComponent && p_cols.length > 0" :p_filters="p_filters" :p_filterData="p_filterData" :p_tblId="p_tblId" :p_columns="p_cols" :p_tableName="p_tableName" @close="m_closeChildWindow" @filters="m_tableFilters" @clearFilters="m_clearFilters")
			div(v-if="p_altViewKey != 'MAPVIEW' && d_showBtns.barPieChart && /^(Opportunities|Projects)$/.test(p_tableName)"   title="Bar and Pie Chart")
				b-dropdown(v-if="!d_dashboardId" right class="btn-menu chart-dropdown" variant="outline-secondary" menu-class="toolbar-dropdown-menu")
					template(v-slot:button-content)
						img(src="@/assets/chartIcon.png" style="width: 25px;")
					kt-barpiechart(:key="d_pieBarChartKey" :p_appEntKey="p_appEntKey"  :p_tableName="p_tableName"  :p_cols="p_cols" :p_tableData="p_tableData" )
			div(v-if="p_altViewKey != 'MAPVIEW' && d_showBtns.reports"  title="Export and Reports")
				b-dropdown(right variant="outline-secondary"  class="btn-menu reports-dropdown" menu-class="toolbar-dropdown-menu reports-dropdown-menu")
					span(class="topright-close" @click="m_closeChildWindow") &times
					template(v-slot:button-content)
						fa-icon(icon="file-export")
					kt-reports(:key="d_componentKey" :p_appEntKey="p_appEntKey" :p_notifyOpt="p_notifyOpt" :p_tableName="p_tableName" :p_refData="p_refData" :p_cols="p_cols" :p_sort="p_sort"  :p_tableData="p_tableData" :p_filters="p_filters")
			div(v-if="d_showBtns.remindOpt" variant="outline-primary" title="Reminders and Notifications")
				b-dropdown( right variant="outline-secondary"  class="btn-menu remind-dropdown" menu-class="toolbar-dropdown-menu" v-b-tooltip.hover.auto.ds500="{title:'Notification Options for ' + c_apppEntName}")
					template(v-slot:button-content)
						fa-icon(icon="bell")
						fa-layers-text(class="kt-bbl" transform="up-15 right-15" :value="c_rmndOptTrue.length" v-if="(c_rmndOptTrue||[]).length")
					kt-remind-opt(:p_appEnt="p_appEntKey"  :p_rmndOpt="c_rmndOpt"   :p_tableName="p_tableName" ) 
			b-button(v-if="d_showBtns.sync" class="btn-refresh btn-menu" title="Refresh" variant="outline-secondary" @click="m_refreshData")
				fa-icon(icon="sync")
			div(v-if="p_altViewKey != 'MAPVIEW' && d_showBtns.toggleColumns" class="col-toggle")
				b-dropdown(right variant="outline-secondary" menu-class="toggleDiv")
					div(class="toggleHeader")
						div(class="dropdown-item mb-2" @click="m_cols_ToggleAll()")
							input(type="checkbox" :checked="d_colsToggleAll" title="All visible")
							span Toggle All
						<span  @click="m_closeChildWindow" class="topright-close">&times</span>
					hr
					draggable(v-model="p_cols" handle=".btn-reorder-cl-item" swapThreshold=.1 animation=150  @end="m_reorderCLItem")
						div(class="dropdown-item" v-for="(col,clix) in p_cols" :key="clix") 
							b-button(class="btn-reorder-cl-item" variant="none" title="Reorder Columns")
								b-icon(icon="arrow-down-up" class="btn-reorder-dashboard")
							input(:id="'visible'+col.field" class="toggleCheckBox" type="checkbox" :checked="col.visible||col.required" title="Visible" :disabled="col.required&&!d_superUser" @change="m_changeVisible(col)")
							input(:id="'readOnly'+col.field" class="toggleCheckBox" type="checkbox" :checked="col.readOnly" title="Read only" :disabled="!d_superUser" @change="m_changeReadOnly(col)" )
							input(:id="'required'+col.field" class="toggleCheckBox" type="checkbox" :checked="col.required" title="Mandatory" :disabled="!d_superUser" @change="m_changeRequired(col)" )
							span {{col.title}}
					hr
				
					span(class="btn btn-link" @click="m_cols_ResetDefaults") Reset Defaults
					span(class="btn btn-link" v-if="p_ctrlKey !='TB'&& p_ctrlKey !='TG'" @click="m_cols_ResetColWidths") Reset Widths
					span(class="btn btn-link" v-if="p_ctrlKey !='TB'&& p_ctrlKey !='TG'" @click="m_cols_ResetColSorts") Reset Sorts
					template(v-slot:button-content)
						fa-icon(icon="th-list")
			slot(name="toolbar-right-r")
</template>

 <script>
import FilterComponent from '@/components/Ctrl/KT-FilterComponent.vue';
import {userSettings,fn_appEnt} from "@/utils/ref-data.js";
import {fn_saveUserOpts} from "@/utils/util.js";
import {fn_getAppUserSettings,fn_getReminderOptions,settings,fn_saveData} from "@/utils/api.js";
import XLSX from 'xlsx/xlsx';
import JsPDF from "jspdf";
import 'jspdf-autotable';
import KTReminderOpts from '@/components/Ctrl/KT-ReminderOpt.vue';
import KTReports from '@/components/Ctrl/KT-Reports.vue';
import draggable from "vuedraggable";
import { eventBus } from '@/main';
import KTBarPieChart from '@/components/Ctrl/KT-BarPieChart.vue';
export default {
	name: "kt-toolbar",
	components: {
		"filter-component":FilterComponent,
		"kt-reports":KTReports,
		"kt-remind-opt":KTReminderOpts,
		draggable,
		"kt-barpiechart":KTBarPieChart,
	},
	created() {
	this.d_appEnt = fn_appEnt(this.p_appEntKey);
	this.d_ktTable = "kt-table-" + this.d_appEnt.key;
	var usrSettings=userSettings;
	this.d_userOptions=usrSettings.userOptions;
	this.d_superUser=usrSettings.permissions.superUser;
	eventBus.$on('saved', (data) => {this.d_rmndOpt=[...data];});
	if (this.p_tableName) {
		this.d_contextId=0;
	switch (this.p_tableName) {
        case "Opportunities":
			this.d_context = "opportunityId";
			break;
        case "Opportunity Activities":
			this.d_context = "opportunityId";
			this.d_ktTable = "kt-task-list-"+this.d_appEnt.name + "Tasks";
			break;
        case "Projects":
			this.d_context = "projectId";
			break;
        case "Project Activities":
			this.d_context = "projectId";
			this.d_ktTable = "kt-task-list-"+this.d_appEnt.name + "Tasks";
			break;
        case "Accounts":
			this.d_context = "accountId";
			break;
        case "Account Activities":
			this.d_context = "accountId";
			this.d_ktTable = "kt-task-list-"+this.d_appEnt.name + "Tasks";
			break;
		case "Calendar Activities":
			this.d_ktTable = 'kt-task-list-calendarTasks';
			break;
		}
	}
	

      console.log("Toolbar before reminderOptions:" + this.d_context+" and contextId:"+this.d_contextId);
		fn_getReminderOptions(this.d_context, this.d_contextId).then((resp) => {
			if (resp) {
				this.d_rmndOpt = resp.reminderOptions;
				//console.log("Toolbar d_rmndOpt");
				//console.log(this.d_rmndOpt);
				}
			});
		
		let category='tableColumnOrder';
		fn_getAppUserSettings(category,this.p_tblId).then((resp) => {
		if(resp){
			//console.log("tableColumnOrder");
			//console.log(resp);
			let tableColumnOrder=resp.value;
			let columns=[];
			let colIndex;
			let colIndex2;
			//console.log(tableColumnOrder);
			if(tableColumnOrder){ 
				for(let i=0; i<tableColumnOrder.length; i++){
					//columns.push(this.p_cols.filter(c=>(c.field==tableColumnOrder[i]))[0]);
					colIndex=this.p_cols.findIndex(c=>c.field==tableColumnOrder[i]);
					if(colIndex>-1) columns.push(this.p_cols[colIndex]);
					}
				console.log("before toolbar columns");
				console.log(columns);
				//Add remaining column if not all.
				if(columns.length<this.p_cols.length){
					this.p_cols.forEach(c=>{
						colIndex2=columns.findIndex(c2=>c2.field==c.field);
						if(colIndex2==-1) columns.push(c);
						});
					}
				console.log("after toolbar columns");
				console.log(columns);
				this.$parent.d_cols=[...columns];
				}
			}
		});
	
	},
	mounted() {
		console.log('In toolbar');
		console.log(this.p_filterData);
		
		
		this.d_showBtns=Object.assign(this.d_showBtns,this.p_showBtns);

	},
	data() {
		return {
			d_colsToggleAll: false,
			d_userOptions:null,     //userSettings.userOptions,
			d_closeFilterWindow:false,
			d_cols:null,
			d_context:null,
			d_contextId:null,
			d_rmndOpt:[],
            d_componentKey:1,
			d_search:null,
			d_responsiveSearch:true,
			d_appEnt:null,
			d_superUser:null,
			d_ktTable:null,
			d_pieBarChartKey:null,
			d_dashboardId:this.$parent.d_qryPrms.dashboardId,
			d_showBtns:{searchBar:true,saveCancel:true,sync:true,barPieChart:true,
						filterComponent:true,remindOpt:true,reports:true,toggleColumns:true},

		};
	},
	props: {
		p_enableSearch: {type: Boolean, default: true},
		p_getData: Function,
		p_cols: Array,
		p_tblId: String,
		p_ctrlKey: String,
		p_tableData:Object,
		p_filterData: {
			type: Object
		},
		p_columns: Array,
		p_altViewKey: String,
		p_appEntKey:String,
		p_tableName:String,
		p_refData:Object,
		p_sort:Array,
		p_filters:Object,
		p_tableEdit:Boolean,
		p_showBtns:Object,
	},
	computed: {
		c_colsTglCat() {return this.p_ctrlKey == 'TB' ? 'boardFieldsVisible' : 'tableColumnsVisible';},
		c_rmndOpt(){ return this.d_rmndOpt;},
		c_rmndOptTrue(){ console.log('In c_rmndOptTrue');console.log(this.d_rmndOpt); return this.d_rmndOpt?this.d_rmndOpt.filter(o=>o.email||o.kbdp):null;},
		//c_showBtns() {return Object.assign(this.d_showBtns,this.p_showBtns);}
	},
	methods: {
		m_closeChildWindow(){
			//this.d_closeFilterWindow=true;
            this.d_componentKey++;
			document.getElementById("searchBar").focus();
			},
		m_exportData(fileType){
		var columns=this.p_cols.filter(x => x.visible);
		let exportData = this.p_tableData.map(a => {
               let newObject = {};
               Object.keys(a).forEach(propertyKey => {
                    newObject[propertyKey] = a[propertyKey];
					var column = this.p_cols.find(c => c.field == propertyKey)
					if(column && column.valFmtFn) newObject[propertyKey] = column.valFmtFn(a[propertyKey]);
               });
               return newObject;
		});

		const date = new Date();
		const fileName =
        "Export" +
        date.getFullYear() +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        ("0" + date.getDate()).slice(-2) +
        ("0" + date.getHours()).slice(-2) +
        ("0" + date.getMinutes()).slice(-2) +
        ("0" + date.getSeconds()).slice(-2);
		
		switch(fileType) {
				case 'Excel':
					fn_exportExcel(exportData, columns,fileName);
				break;
				case 'pdf':
					var pdfRecord=[];
					var pdfData=[];
					exportData.forEach(rec =>{
							columns.forEach(col => {
							var val=rec[col.field];
							pdfRecord.push(val?val:null);
						});
						pdfData.push(pdfRecord);
						pdfRecord=[];
					});
					fn_exportPdf(pdfData, columns,fileName);
				break;
				default:
				// code block
		}
		
		
		
		},
		m_refreshData() {
			let dp = this.$parent.d_dataParams;
			dp.search = null;
			dp.offset = 0;
			this.$emit('clearFilters', null);
			this.p_getData(true);
		},
		m_search(e) {
			let dp = this.$parent.d_dataParams;
			dp.search = e.target.value || null;
			dp.offset = 0;
			//this.p_getData();
			this.$emit('search', e.target.value|| null);
		},

		m_cols_ToggleAll() {
			this.d_colsToggleAll = !this.d_colsToggleAll;
			this.p_cols
				.filter(x => !x.noToggle)
				.forEach(x => (x.visible = this.d_colsToggleAll));

			fn_cols_min1Visible(this);
			fn_saveUserOpts(this.p_tblId, this.c_colsTglCat, {_all: true});
		},
		m_cols_Toggle(col) {
			col.visible = col.noToggle ? col.visible : !col.visible;
			this.d_colsToggleAll = false;
			fn_cols_min1Visible(this);
			let val = {};
			this.p_cols.forEach(x => {
				let isChg = x.visible !== null && x.visible != (x.default == true);
				if (isChg) val[x.field || x.key] = x.visible;
			});
			fn_saveUserOpts(this.p_tblId, this.c_colsTglCat, val);
		},
		m_cols_ResetDefaults() {
			this.d_colsToggleAll = false;
			this.p_cols
				.filter(x => !x.noToggle)
				.forEach(x => (x.visible = x.default ? true : null));


			fn_saveUserOpts(this.p_tblId, this.c_colsTglCat, {_defaults: true});
		},
		m_cols_ResetColWidths() {
			this.p_cols.forEach(x => x.width = null);
			this.$parent.d_opts.width = null;
			fn_saveUserOpts(this.p_tblId, 'tableColumnWidths', {});
		},
		m_cols_ResetColSorts() {
			this.p_cols.forEach(x => x.sort = null);
			this.$parent.d_dataParams.order = [];

			fn_saveUserOpts(this.p_tblId, 'tableColumnSorts', {});
			this.p_getData();
		},
		m_tableFilters(data) {
			this.$emit('filters', data);
		},
		m_clearFilters(data) {
			this.$emit('clearFilters', data);
		},
		m_reorderCLItem() {
				this.$parent.d_cols=[...this.p_cols];
				let columnOrder=this.p_cols.map(c=>{return c.field});
				fn_saveUserOpts(this.p_tblId, 'tableColumnOrder', columnOrder);
		},
		m_toggleSearch(){this.d_responsiveSearch=!this.d_responsiveSearch;},
		m_changeVisible(col){
			col.visible = col.noToggle ? col.visible : !col.visible;
			this.d_colsToggleAll = false;
			fn_cols_min1Visible(this);
			let val = {};
			this.p_cols.forEach(x => {
				let isChg = x.visible !== null && x.visible != (x.default == true);
				if (isChg) val[x.field || x.key] = x.visible;
			});
			fn_saveUserOpts(this.p_tblId, this.c_colsTglCat, val);
		},
		m_changeReadOnly(col) {
			col.readOnly = !col.readOnly;
			var val=this.p_cols.filter(x=>x.readOnly).map(x=>{return x.field;});
			settings.fn_saveData('appTenantSetting', 'tableReadOnlyColumns', {prop:this.d_ktTable, value:JSON.stringify(val)});
		},
		m_changeRequired(col) {
			col.required = !col.required;
			var val=this.p_cols.filter(x=>x.required).map(x=>{return {field:x.field,title:x.title};});
			settings.fn_saveData('appTenantSetting', 'tableRequiredColumns', {prop:this.d_ktTable, value:JSON.stringify(val)});
		},
		m_tableSave() {
			this.$emit('save',null);
		},
		m_tableCancel() {
			this.$emit('cancel',null);
		},	

	},
	watch: {
		p_cols(nv) {
			console.log('watch toolbar p_cols');
			console.log(nv);
			fn_setColsTglAll(this);
			
		},
		p_tblId(nv) {
			fn_setColsTglAll(this);
		},
		'd_userOptions.showRecordNumbers'(nv, ov) {
			let cnk = this.p_cols.filter(x => x._numKey)[0];
			if (cnk) cnk.default = cnk.visible = nv;
		},
	
		d_search(nv) {
				if(this.d_responsiveSearch){
					let dp = this.$parent.d_dataParams;
					dp.search = nv|| null;
					dp.offset = 0;
					this.$emit('search', nv|| null);
					} 
				},
		p_showBtns(nv,ov){console.log('watch toolbar p_showBtns',nv);},
		
	}
};
function fn_cols_min1Visible(vc) {
	let cols = vc.p_cols;
	let vlen = cols.filter(x => x.visible).length;
	switch (vlen) {
		case 0: {
			cols[0].visible = true;
			cols[0].disabled = true;
			break;
		}
		case 1: {
			cols.filter(x => x.visible)[0].disabled = true;
			break;
		}
		case cols.length: {
			vc.d_colsToggleAll = true;
			break;
		}
		default: {
			cols.filter(x => x.disabled).forEach(x => delete x.disabled);
			break;
		}
	}
}
function fn_setColsTglAll(vc) {
	vc.d_colsToggleAll = vc.p_cols.filter(x => !x.visible).length == 0;
}

function fn_exportExcel(data, columns, filename) {

	console.log('In fn_exportExcel');
	
	let createXLSLFormatObj = [];
	let newXlsHeader = [];
	if (columns.length === 0){
	return;
	}
	if (data.length === 0){
	return;
	}
	columns.map(column => {
	newXlsHeader.push(column.title);
	});
	createXLSLFormatObj.push(newXlsHeader);
	data.map(value => {
	let innerRowData = [];
	columns.map(val => {
	let fieldValue = value[val.field];
	
	if (val.field.split('.').length > 1) {
		fieldValue = fn_getNestedValue(value, val.field);
	}
	if (val.dataFormat && typeof val.dataFormat === 'function') {
		innerRowData.push(val.dataFormat(fieldValue));
	} else { 

	innerRowData.push(fieldValue);  
	} 
	
	//innerRowData.push(fieldValue);
	
		});
		
		console.log(innerRowData);
		
		createXLSLFormatObj.push(innerRowData);
		console.log('In fn_exportExcel4');
		});


	
	let fileName = filename + "." + 'xlsx';
	//let fileName='Export001.xlsx';
	let ws_name = filename;
	
	let wb = XLSX.utils.book_new(),
	ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
	XLSX.utils.book_append_sheet(wb, ws, ws_name);
	XLSX.writeFile(wb, fileName);
	}
			
function fn_getNestedValue(object, string) {

	string = string.replace(/\[(\w+)\]/g, '.$1');
	string = string.replace(/^\./, '');
	let a = string.split('.');
	for (let i = 0, n = a.length; i < n; ++i) {
	let k = a[i];
	if (k in object) {
		object = object[k];
		} else {
			return;
			}
		}
		return object;
	}
	
function fn_exportPdf(data,columns,fileName) {

    const headerNames = columns.map((column) => column.title);
	
    const doc = new JsPDF({orientation: 'l', // landscape
        unit: 'pt', // points, pixels won't work properly
  });

	
    doc.autoTable({
      head: [headerNames],
      body: data,
      margin: { top: 20 },
      styles: {
        minCellHeight: 9,
        halign: "left",
        valign: "center",
        fontSize: 11,
      },
    }); 

	doc.save(`${fileName}.pdf`);
}

</script>

<style lang="less">
.kt-toolbar {
	font-size: 0.9em;
	display: flex;
	flex-wrap: wrap;
	margin: 0.2em 0em;
	align-items: center;
	.btn-toolbar {
		min-width: 60px;
		padding: 0em 0.4em;
		//margin-right: 0.5em;
		color: #4fa4ff;
			svg {
				margin-right: 0.4em;
				font-size: 0.9em;
			}
		}


	justify-content: space-between;
	> div {
		display: flex;
		margin: 0.2em 0;
		line-height: 1;
		align-items: center;
	}
	> div:first-child {
		margin: auto 0;
		line-height: 1.5em;
	}
	> div:last-child {
		gap:0.25rem;

		> .btn-refresh {
			margin-right: 0px;
			margin-left: 0px;
		}
	}

	.btn-export .btn.dropdown-toggle {
		margin: 0px;
	}
	
	
	.input-search {
		padding: 0.4em;
		margin-right: 0.3em;
		width: 400px;     //160px;
		outline: unset;
		border: solid 0.1em #adb5bd;
		font-size: 0.9em;
		// border-radius: 0.25em;
		&:focus {
			box-shadow: 0em 0.01em 0.01em 0.05em #ced4da;
		}
	}

	.btn-add {
		font-size: 0.9em;
		padding: 0em 0.3em;
	}

	.btn-cuFilter,
	.btn-refresh,
	.swimln-toggle button.dropdown-toggle,
	.col-toggle button.dropdown-toggle {
		font-size: 1em;
		margin-right: 0.3em;
		padding: 0em 0.3em;
		border-radius: 0.15em;
	}
	.btn-cuFilter {
		margin-right: 0;
	}

	.swimln-toggle,
	.col-toggle {
		ul.dropdown-menu {
			padding: 0.5em 0;
			max-height: 415px;
			// height: auto;
			// max-height: 60vh;
			min-width: 150px;
			overflow-y: auto;

			.dropdown-item {
				padding: 0.2em 0.75em;
				display: flex;
				> input[type="checkbox"],
				> input[type="radio"] {
					margin: auto 0;
				}
				span {
					cursor: default;
					padding-left: 0.5em;
					font-size: 0.9em;

					&.asc::after {
						content: " ↑a-z";
						color: #4fa4ff;
					}
					&.desc::after {
						content: " ↓z-a";
						color: #4fa4ff;
					}
				}
			}
			> span.btn {
				font-size: 0.9em;
				padding: 0em 0.75em;
				width: 100%;
				text-align: left;
				&:first-of-type {
					margin-top: 0.5em;
				}
			}

			&::-webkit-scrollbar {
				width: 0.6em;
			}
		}
	}

	&.TB {
		.col-toggle .dropdown-item span::after {
			display: none;
		}
	}
}
.btn-reorder-cl-item
	{
	opacity: 0.5;
	font-size: 0.8em;
	background-color: #e9ecef;
	box-shadow: unset;
	&:hover {
			opacity: unset;
			}
	}
hr {
    color: #ddd;
    background-color: #ddd;
    height: 1px;
    border: none;
    max-width: 100%;
	margin: 0.0em;
}

.kt-bbl {background-color: #4fa4ff;}
.draggingIcon{background-color: #4fa4ff;}
.topright-close {
  float: right;
  cursor: pointer;
  font-size: 28px;
}
.topright-close:hover {color: green;}
.btn-reorder-dashboard {
	cursor: move;
	padding: 0;
}
.btn-menu{border:none;}
.toolbar-dropdown-menu.dropdown-menu {
	padding: 0 !important;
	margin: 0;
	border: none !important;
	background: transparent !important;
	box-shadow: none !important;
	overflow: visible;
}
.reports-dropdown-menu.dropdown-menu {
	min-width: 240px;
}
.reports-dropdown-menu .topright-close {
	position: absolute;
	top: 2px;
	right: 8px;
	float: none;
	font-size: 20px;
	line-height: 1;
	z-index: 2;
	background: transparent;
}
.btn-chart-menu{border:none;}
.btn-outline-secondary {
   border:none;
}
.btn-menu-sm{
	border:none;
	width:20px;
	height:20px;
}
.searchBar {
		position: relative;
		width1: 100%;
		div.input {
			padding: 0.155em 0.2em;
			padding-right: 1.5em;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			border-radius: 0.25rem;
			border: 1px solid #ced4da;
			}
	.btn-clear,
    > svg[data-icon="search"] {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.4em;
      font-size: 0.8em;
      opacity: 0.4;
      &.btn-clear {
        background-color: #e9ecef;
        &:hover {
          opacity: unset;
        }
      }
    }
  div.input.styled-input {
      border: 0px;
      border-radius: 0px;
      border-bottom: 1px solid #000000;
    }
}
.searchCheckbox{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2em;
    font-size: .8em;
    opacity: .4;
	width: auto !important;
}
[type=checkbox]:checked{
  background: #4fa4ff;
}
.toggleDiv.dropdown-menu {
	position: sticky;
	top: 0px;
	z-index: 10;
	background: #fff !important;
	padding: 0 !important;
	border: none !important;
	border-radius: 6px;
	overflow: hidden;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}
.toggleHeader{
    display:flex;
	position:sticky;
	top:0px;  
	z-index: 9;
    background: white;
}
.toggleCheckBox{
margin-left: 2px !important;
width: 12px !important;
}
.icon-wrapper {
  position: relative;
  display: inline-block;
}

.icon-label {
  position: absolute;
  top: -4px;        /* adjust vertical position */
  right: -10px;     /* adjust horizontal position */
  font-size: 0.55rem;
  font-weight: 600;
  pointer-events: none;
}
.action-btn {
   display: inline-flex;
   align-items : center;
   gap: 10px;
   height: 44px;
   padding: 0 18px;
   background: transparent;
   color: black;
   border: none;
   border-radius: 9999px;
   font-weight: 600;
   font-size: 14px;
   
   box-shadow: 0 4px 12px rgba(37,99,235,.35);
   transition: all .2s ease;
}
.action-btn1:hover {
     transform: translateY(-1px);
     box-shadow: 0 8px 20px rgba(37,99,235,.35);
}
.action-btn:hover .icon {
     transform: translateY(2px);
}
.action-btn:hover .icon {
     transform: translateY(2px);
}
.action-btn .icon {
     transition: all .2s ease;
}
.btn-save {
    color: #fff;
    background-color: #4fa4ff;
    border-color: none;
}
.btn-cancel {
     color: red;
     background-color: #ffc107;
     border-color: none;
}
.btn-save:hover{
     background-color: #3f83cc !important;
}
.btn-cancel:hover {
  background-color: #e6ac06 !important;
}
</style>